export default __webpack_public_path__ + "static/media/sonia.5327b35f.jpg";